import type { User } from '@/features/user/types';
import { api } from '@/api';

export const getLoggedUser = (token?: string) =>
  api.get<User>(
    'v1/users/logged',
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );

export const updateUserProfile = (payload: {
  firstName: string;
  lastName: string;
  systemLanguage: string;
  defaultTranslationLanguage: string;
}) => api.put('v1/users/logged', payload);
